import Header from 'govbr.frontend.policy/components/Header/Header';

export default Header;
